<template>
  <div class="border">
    <div :class="{'kne-title' : title}">
      <h3 v-if="!hideTitleonPrint">{{title}}</h3>

      <slot name="header-actions" v-if="!hideTitleonPrint"></slot>
    </div>

    <slot class="text-center" name="pre-body-content">
    </slot>

    <paginate :refreshCurrentPage="false" ref="paginator" name="tableResults" tag="div" class="table-wrapper" :list="tableResults" :per="pageSize" :id="id">
        <!-- Desktop -->
        <draggable
        :key="id"
        @update="onDragOrderChange"
        draggable=".draggable-item"
        :disabled="!isDraggable"
        tag="table"
        :options="{handle:'.drag-handle'}"
        class="table table-repsonsive table-hover font-grey mb-0 table-sm"
        v-if="!isScreenSmall"
        >
        <transition-group name="fade" tag="tbody">

          <!-- Sort -->
          <tr class="bg-darkgrey sort-border" id="sort" key="sort">
            <th v-if="sortSpacing > 0" :colspan="sortSpacing"></th>
            <th v-for="field in conditionalFields" :key="field.type" class="nowrap text-center py-2" :class="{'sortable' : field.type !== '' && sortable === true}" @click="onSort(field.type, false)">
              <span v-html="field.text"></span>
              <i v-if="sort.current === field.type || (sort.current === 'size' && field.type === 'model')" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true" />
            </th>
            <th v-if="sortSpacingEnd > 0" :colspan="sortSpacingEnd"></th>
          </tr>

          <!-- Filters -->
          <tr v-if="isShowFilter" id="filter" key='filter' class="table-element_hover">
            <td v-if="isShowSelectAll" class="pt-2">
              <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
                <input :value="areAllOrdersSelected" @click="onSelectAllOrders()" type="checkbox" class="custom-control-input">
                <span class="custom-control-indicator"></span>
              </label>
            </td>
            <th v-if="sortSpacing > 0 && isShowSelectAll" :colspan="sortSpacing - 1"></th>
            <th v-if="sortSpacing > 0 && !isShowSelectAll" :colspan="sortSpacing"></th>
            <td v-for="field in conditionalFields" :key="field.type">
              <regular-input
                v-if="field.type !== '' && field.type !== 'survey'"
                :value="field.value"
                :placeholder="field.text"
                @input="field.value = $event;
                evaluateFiltering(field.type, $event)"
              />
            </td>
          </tr>

          <!-- List of element -->
          <slot id="content" name="body-content-desktop"  :results="paginated('tableResults')"></slot>

        </transition-group>
      </draggable>

      <!-- Mobile -->
     
      <transition-group class="mobile-table-wrapper" style="display: block;" name="fade" tag="tbody"  v-else>
        <div key="mobile">
          <search-filter
          v-if="isShowFilter"
          key="SearchFilter"
          :fields="fields"
          :sort="sort"
          @callFilteredSearchMethod="filteredSearchMethod(fields)"
          @sortBySearchFilter="(field, bool) => this.sortBy(field, bool)"
          />
          <hr>
          <draggable
          :key="id"
          @update="onDragOrderChange"
          tag="div"
          draggable=".draggable-item"
          :options="{handle:'.drag-handle'}"
          :disabled="!isDraggable"
          >
          <slot name="body-content-mobile" :results="paginated('tableResults')"></slot>
        </draggable>
        </div>
      </transition-group>
      <hr>
    </paginate>
    <paginate-links @change="onPageChange" for="tableResults" :hide-single-page="true" :limit="10"></paginate-links>

    <slot class="text-center" v-if="!hideTitleonPrint" name="post-body-content">
    </slot>

  </div>
</template>

<script>
// import _ from 'lodash'
import moment from 'moment'

import CustomJsonExcel from '../Custom-packages/Custom-JsonExcel.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import regularInput from '../../basic-components/regularInput.vue'
import SearchFilter from '../../basic-components/SearchFilter.vue'
import Draggable from 'vuedraggable'
import { dryBoxMixin } from '../../../../utils/dryBoxLabels'

const IDENTITY_FIELD_SECTIONS = { payerName: 'payer', transmitterName: 'transmitter', receiverName: 'receiver' }

export default {
  name: 'TableList',
  components: {
    CustomJsonExcel,
    hoverToolTip,
    regularInput,
    SearchFilter,
    Draggable
  },

  mixins: [dryBoxMixin],

  data () {
    return {
      paginate: ['tableResults'],
      sort: {},
      selected: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      tableResults: [],
      areAllOrdersSelected: false,
      pageIndex: 0
    }
  },

  props: {
    title: {
      type: String,
      required: false
    },
    hideTitleonPrint: {
      type: Boolean,
      required: false,
      default: false
    },
    fields: {
      type: [Array, Object],
      required: true
    },
    arrOfElement: {
      type: Array,
      required: true
    },
    sortSpacing: {
      type: Number,
      required: false
    },
    sortable: {
      type: Boolean,
      required: false,
      default: true
    },
    isShowFilter: {
      type: Boolean,
      required: false
    },
    isShowSelectAll: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: String,
      required: false,
      default: ''
    },
    initialSort: {
      type: String,
      required: false,
      default: '.key'
    },
    driversSort: {
      type: Boolean,
      required: false,
      default: false
    },
    groupSort: {
      type: Boolean,
      required: false,
      default: false
    },
    sortSpacingEnd: {
      type: Number,
      requried: false,
      default: 0
    },
    isDraggable: {
      type: Boolean,
      required: false,
      default: false
    },
    pageSize: {
      type: Number,
      required: false,
      default: 40
    }
  },

  methods: {
    fieldValue (order, type) {
      const section = IDENTITY_FIELD_SECTIONS[type]
      return section ? this.$realName(order, section) : order[type]
    },
    scrollToRow (zoneName) {
      this.$nextTick(() => {
        const targetRow = this.$el.querySelector(`[data-zone-name="${zoneName}"]`)
        if (targetRow) {
          targetRow.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      })
    },
    onSort (fieldType, value) {
      if (fieldType === 'model' && !this.isDryBox) {
        fieldType = 'size'
      }
      this.sortBy(fieldType, value)
      this.$emit('updateFinalData', this.tableResults)
    },
    onPageChange (pageNumber) {
      this.pageIndex = pageNumber - 1
    },
    onDragOrderChange (event) {
      // 1. Get the old and new indices of the item being dragged
      const oldIndex = this.pageIndex * this.pageSize + event.oldDraggableIndex
      const newIndex = this.pageIndex * this.pageSize + event.newDraggableIndex
      // 2. Get the array which needs to be updated
      const finalData = this.tableResults
      // 3. Remove the dragged element from its original position
      const [draggedElement] = finalData.splice(oldIndex, 1)
      // 4. Insert the dragged element at the new position
      finalData.splice(newIndex, 0, draggedElement)
      // 5. Update the result in parent as well
      this.$emit('updateFinalData', this.tableResults)
    },
    onSelectAllOrders () {
      if (!this.areAllOrdersSelected) {
        this.paginated('tableResults').forEach(order => {
          this.selected.push(order['.key'])
        })
        this.areAllOrdersSelected = true
      } else {
        this.selected = []
        this.areAllOrdersSelected = false
      }

      this.$emit('updateSelectedOrders', this.selected)
    },

    /** Big chungus for filtering all orders
     * @param fields (Object) - Contains the possible search fields that are displayed on the table
     */
    filteredSearchMethod (fields) {
      this.tableResults = []
      let processingCopy = [...this.arrOfElement]

      processingCopy = this.checkRouteQueryVar(processingCopy) // If there are Route.Query filters in the URL

      this.tableResults = processingCopy.filter((order) => {
        let results = true

        for (let field in fields) {
          if (fields[field].value !== '') { // Only perform checks on fields with a searched value
            let cleanValue = fields[field].value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') // Strip special characters from search
            let reFirstMatch = new RegExp(cleanValue, 'i') // Match with first value (i)

            if (fields[field].type === 'creationDate' || fields[field.type] === 'date') { // If searched field type is creationDate or date
              let date = this.getDate(fields[field].value)
              results = reFirstMatch.test(date)
            } else if (fields[field].type === 'status') { // If searched field type is status
              if (order.status === 'Dispatch') results = reFirstMatch.test(this.$t('Search.status.dispatch'))
              else if (order.status === 'Pick') results = reFirstMatch.test(this.$t('Search.status.pick'))
              else if (order.status === 'Processing') results = reFirstMatch.test(this.$t('Search.status.processing'))
              else if (order.status === 'Attente') results = reFirstMatch.test(this.$t('Search.status.waiting'))
              else if (order.status === 'Transit') results = reFirstMatch.test(this.$t('Search.status.transit'))
              else if (order.status === 'Drop') results = reFirstMatch.test(this.$t('Search.status.drop'))
              else if (order.status === 'Cancel') results = reFirstMatch.test(this.$t('Search.status.canceled'))
              else if (order.status === 'Terminée') results = reFirstMatch.test(this.$t('Search.status.finished'))
              else if (order.status === 'Transférée') results = reFirstMatch.test(this.$t('Search.status.transfered'))
              else if (order.status === 'Reject') results = reFirstMatch.test(this.$t('Search.status.rejected'))
              else if (order.status === 'Inspection') results = reFirstMatch.test(this.$t('Search.status.inspection'))
              else if (order.status === 'Approved') results = reFirstMatch.test('Approved')
              else if (order.status === 'Denied') results = reFirstMatch.test('Denied')
              else if (order.status === 'Pending') results = reFirstMatch.test('Pending')
              else results = false
            } else {
              results = reFirstMatch.test(this.fieldValue(order, fields[field].type)) // Rest of possible search types
            }
          }
          if (results === false) break
        }
        return results
      })

      if (!this.groupSort) {
        this.tableResults.reverse()
      }
      this.sortBy(this.sort.current, true)
      let paginator = this.$refs.paginator
      let maxPage = Math.ceil(this.tableResults.length / paginator.per)
      if (paginator.currentPage + 1 > maxPage && maxPage !== 0) paginator.goToPage(1)
      this.$emit('updateFilterResults', this.tableResults) // Emit to the parent component the updated results
    },

    checkRouteQueryVar (processingCopy) {
      if (this.$route.query.customView === true || this.$route.query.customView === 'true') {
        // Will filter by source if this.$route.query.source is specified in url
        if (this.$route.query.source) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.source || '').toLowerCase() === this.$route.query.source.toLowerCase()
          })
        }
        // Will filter by reference if this.$route.query.reference is specified in url
        if (this.$route.query.reference) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.numRef || '').toLowerCase() === this.$route.query.reference.toLowerCase()
          })
        }
        // Will filter by vin if this.$route.query.vin is specified in url
        if (this.$route.query.vin) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.vin || '').toLowerCase() === this.$route.query.vin.toLowerCase()
          })
        }
        // Will filter by billing if this.$route.query.billing is specified in url
        if (this.$route.query.billing) {
          processingCopy = processingCopy.filter((entry) => {
            return this.$realName(entry, 'payer').toLowerCase() === this.$route.query.billing.toLowerCase()
          })
        }
        // Will filter by delivery if this.$route.query.delivery is specified in url
        if (this.$route.query.delivery) {
          processingCopy = processingCopy.filter((entry) => {
            return this.$realName(entry, 'receiver').toLowerCase() === this.$route.query.delivery.toLowerCase()
          })
        }
        // Will filter by driver if this.$route.query.driver is specified in url
        if (this.$route.query.driver) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.driverName || '').toLowerCase() === this.$route.query.driver.toLowerCase()
          })
        }
        // Will filter by pickup if this.$route.query.pickup is specified in url
        if (this.$route.query.pickup) {
          processingCopy = processingCopy.filter((entry) => {
            return this.$realName(entry, 'transmitter').toLowerCase() === this.$route.query.pickup.toLowerCase()
          })
        }
        // Will filter by from if this.$route.query.from is specified in url
        if (this.$route.query.from) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate > this.$route.query.from
          })
        }
        // Will filter by to if this.$route.query.to is specified in url
        if (this.$route.query.to) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < this.$route.query.to
          })
        }
        // Will filter by status if this.$route.query.status is specified in url
        if (this.$route.query.status) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.status || '').toLowerCase() === this.$route.query.status.toLowerCase()
          })
        }
        // Will filter by after date if this.$route.query.after is specified in url
        if (this.$route.query.after) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < moment().subtract(this.$route.query.after, 'days').valueOf()
          })
        }
        // Will filter by before date if this.$route.query.before is specified in url
        if (this.$route.query.before) {
          processingCopy = processingCopy.filter((entry) => {
            return entry.creationDate < moment().subtract(this.$route.query.before, 'days').valueOf()
          })
        }
        // Will filter by province of pickup if this.$route.query.provincePick is specified in url
        if (this.$route.query.provincePick) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.transmitterProvince || '').toLowerCase() === this.$route.query.provincePick.toLowerCase()
          })
        }
        // Will filter by province of drop if this.$route.query.provinceDrop is specified in url
        if (this.$route.query.provinceDrop) {
          processingCopy = processingCopy.filter((entry) => {
            return (entry.receiverProvince || '').toLowerCase() === this.$route.query.provinceDrop.toLowerCase()
          })
        }
      }

      // Will filter by newNote if this.$route.query.newNote is specified in url
      if (this.$route.query.newNote) {
        processingCopy = processingCopy.filter((entry) => {
          return entry.read === false
        })
      }

      if (this.$route.query.newDate) {
        processingCopy = processingCopy.filter((entry) => {
          return entry.datePromis !== null && entry.datePromis !== '' && entry.datePromis !== undefined
        })
      }

      return processingCopy
    },

    sortBy (criteria, newEntry) {
      if (criteria === '' || !this.sortable) return

      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }

      this.tableResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''

        let A = a[criteria]
        let B = b[criteria]

        if (criteria === 'survey') { // If sorting by 'Survey' etc.
          const arrWithABValues = this.getVehicleTimestamp(A, B)
          A = arrWithABValues[0]
          B = arrWithABValues[1]
        } else if (this.isDryBoxNumericField(criteria)) {
          A = parseFloat(a[criteria]) || 0
          B = parseFloat(b[criteria]) || 0
        } else if (criteria !== 'creationDate' && criteria !== 'date' && criteria !== '.key' && criteria !== 'phone' && criteria !== 'price' && criteria !== 'deliveryOrder') {
          A = this.fieldValue(a, criteria).toString().toUpperCase() // ignore upper and lowercase
          B = this.fieldValue(b, criteria).toString().toUpperCase() // ignore upper and lowercase
        } else {
          A = parseInt(a[criteria])
          B = parseInt(b[criteria])
        }

        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    },

    getDate: function (timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    /** Whenever changes/updates are made to the list of orders, this function is called to perform the necessary filtering/ordering
     * @param attr (String) - The filtered field
     * @param val (String) - The value that was entered in the field
    */
    evaluateFiltering (attr, val) {
      this.fields.forEach((element, index) => {
        if (element.type === attr) this.fields[index].value = val
      })

      this.filteredSearchMethod(this.fields)
    },

    setSearchedItemTag (attr) {
      let storedTag
      if (attr === '.key') { storedTag = this.$t('OrderCurrent.order') }
      if (attr === 'creationDate') { storedTag = this.$t('OrderCurrent.date') }
      if (attr === 'status') { storedTag = this.$t('OrderCurrent.status') }
      if (attr === 'driverName') { storedTag = this.$t('OrderCurrent.driver') }
      if (attr === 'numRef') { storedTag = this.$t('OrderCurrent.reference') }
      if (attr === 'source') { storedTag = this.$t('OrderCurrent.source') }
      if (attr === 'vin') { storedTag = this.fieldLabel('vin') }
      if (attr === 'transmitterName') { storedTag = this.$t('OrderCurrent.pickup') }
      if (attr === 'receiverName') { storedTag = this.$t('OrderCurrent.delivery') }
      if (attr === 'payerName') { storedTag = this.$t('OrderCurrent.billing') }
      return storedTag
    },

    /** Gets the timestamp of when the vehicles are ready to sort them by time on the order table
     * Returns an @array with both values needed
    */
    getVehicleTimestamp (survey1, survey2) {
      let timestamp1 = this.setVehicleTimestamp(survey1)
      let timestamp2 = this.setVehicleTimestamp(survey2)

      let arrWithValuesToCompare = []
      arrWithValuesToCompare.push(timestamp1, timestamp2)

      return arrWithValuesToCompare
    },

    /** Sets that sheeet, if question IDs are changed in KNEQuick, make sure to change it here too D: */
    setVehicleTimestamp (survey) {
      let questionArr = survey[Object.keys(survey)]
      let timestamp = 0

      if (questionArr) {
        let question1P1 = questionArr.find(question => question.id === '1.1')

        if (typeof question1P1 !== 'undefined') {
          timestamp = this.getTimestamp(question1P1.answer)
        } else timestamp = 1
      }

      return timestamp
    },

    getTimestamp (receivedDate) {
      let timestamp = Date.parse(receivedDate)
      return timestamp
    },

    isDryBoxNumericField (criteria) {
      return this.isDryBox && ['make', 'model', 'trim', 'year', 'weight', 'realWeight', 'linearFeet'].includes(criteria)
    },

    checkSageIdField (mapFields, field, index) {
      if (field.type.toLowerCase() === 'sageid' && !this.isSageOne) {
        let emptyItem = {
          text: '',
          type: '',
          value: ''
        }
        mapFields.splice(index, 1, emptyItem) // Remove element at index and replace with an emptyItem for UX purposes.
      }

      return mapFields
    },

    onResize: window._.debounce(function () {
      this.isScreenSmall = window.innerWidth < 600
    }, 50)
  },

  mounted () {
    this.onResize()
    this.isScreenSmall = window.innerWidth < 500
    if (!this.driversSort) {
      this.sort = {
        current: this.initialSort,
        desc: true
      }
    }
    this.filteredSearchMethod(this.fields)
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  computed: {
    conditionalFields () {
      let mapFields = this.fields

      mapFields.forEach((field, index) => {
        let newFields = this.checkSageIdField(mapFields, field, index)
        mapFields = newFields
      })

      return mapFields
    },

    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },

    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },

    isDateRoute () {
      return this.$route.query.newDate
    }
  },

  watch: {
    arrOfElement: function () {
      this.filteredSearchMethod(this.fields)
    },
    '$route.query': function (val) {
      // console.log(val)
      this.filteredSearchMethod(this.fields)
    }
  }
}
</script>

<style>
  .table-wrapper {
    overflow-x: auto;
  }
  #action {
    display: flex;
    justify-content: end;
  }
  .sort-border {
    border-top: 2px solid #2c2d2f;
  }
</style>
